import React from "react";
import {
  BoardLabel,
  BoardBadge,
  BoardDueDate,
  BoardAvatarStack,
} from "../../atoms/BoardDesignSystem";
import { formatEstimatedHours } from "../../../app/utils/projectBoard/boardDesignTokens";
import "./BoardCard.scss";

const BoardCard = ({ card, boardId, dimmed = false, onClick }) => {
  const checklistDone = (card.checklist || []).filter((i) => i.checked).length;
  const checklistTotal = (card.checklist || []).length;

  const handleKeyDown = (e) => {
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      onClick?.(card);
    }
  };

  return (
    <div
      role="button"
      tabIndex={0}
      className={`pb-card ${dimmed ? "pb-card--filtered-out" : ""}`}
      onClick={() => onClick?.(card)}
      onKeyDown={handleKeyDown}
    >
      {card.coverUrl && (
        <div
          className="pb-card__cover"
          style={{ backgroundImage: `url(${card.coverUrl})` }}
        />
      )}

      {card.labelIds?.length > 0 && (
        <div className="pb-card__labels">
          {card.labelIds.map((id) => (
            <BoardLabel key={id} labelId={id} boardId={boardId} />
          ))}
        </div>
      )}

      {card.ticketNo && (
        <span className="pb-card__ticket">{card.ticketNo}</span>
      )}

      <p className="pb-card__title">{card.title}</p>

      <div className="pb-card__meta-row">
        <div className="pb-card__badges">
          {checklistTotal > 0 && (
            <BoardBadge icon="☑">
              {checklistDone}/{checklistTotal}
            </BoardBadge>
          )}
          {card.attachmentCount > 0 && (
            <BoardBadge icon="📎">{card.attachmentCount}</BoardBadge>
          )}
          {card.commentCount > 0 && (
            <BoardBadge icon="💬">{card.commentCount}</BoardBadge>
          )}
          {card.estimatedHours != null && card.estimatedHours !== "" && (
            <BoardBadge icon="⏱">{formatEstimatedHours(card.estimatedHours)}</BoardBadge>
          )}
          {card.dueDate && <BoardDueDate dueDate={card.dueDate} />}
        </div>
        {card.assignees?.length > 0 && (
          <BoardAvatarStack members={card.assignees} max={3} />
        )}
      </div>
    </div>
  );
};

export default BoardCard;
